// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  position: relative;
  background: black;
  text-transform: capitalize;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.05);
  width: 100%;
  height: 55px;
  margin-bottom: 20px;
}

.wrapper {
  color: var(--ion-color-primary);
  display: flex;
  flex-direction: column;
}

.separator {
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background: white;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  max-width: max-content;
  margin-right: auto;
}
.footer-lang div {
  text-align: center;
  width: 48%;
  border: 1px solid #0f0f0e;
  background: #3c3c3b;
  border-radius: var(--radius-default);
  overflow: hidden;
  padding: 2px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-lang div span {
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-white);
}
.footer-lang div ion-icon {
  height: 15px;
  width: 15px;
  margin-right: 0;
}
.footer-lang div.selected {
  background: var(--ion-color-secondary);
  border-color: var(--ion-color-secondary);
}
ion-col {
  font-size: 13px;
  font-family: AppFontSemiBold;
  color: #000;
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

.logout {
  margin: 20px 0px 0px 10px;
}
.logout ion-button {
  padding: 10px 0px;
  font-family: AppFont, sans-serif;
  text-transform: capitalize;
  --background: white;
  color: var(--ion-color-primary);
  font-weight: 700;
}
.logout ion-button ion-icon {
  zoom: 1;
  color: var(--ion-color-primary);
}

.header-wrap {
  margin: 10px;
}

.lang-row {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  background: #80735d;
  padding: 15px;
}
.lang-row ion-icon {
  zoom: 1.3;
}

.lang-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lang-section ion-button {
  width: 48%;
  --border-color: #303030;
  --background: transparent;
  --border-width: 2px;
  --border-style: solid;
  border-radius: 3px;
  --border-radius: 3px;
  overflow: hidden;
  background: transparent;
  font-weight: bold;
}

.icon-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.icon-lang ion-icon {
  margin: 0px !important;
  padding: 0px !important;
  zoom: 1.6;
}

.lang-block {
  margin-top: 10rem;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.link {
  display: flex;
  align-items: center;
}

.top-corner {
  position: fixed;
  top: 0px;
  left: 0;
  width: 17.3%;
  aspect-ratio: 114/153;
}
@media (min-width: 991px) {
  .top-corner {
    display: none;
  }
}

.logo {
  width: 39px;
  height: 38px;
  padding: 0;
  padding-left: 16px;
}

.item {
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,iBAAA;EACA,0BAAA;AADD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAAD;;AAEA;EACC,+BAAA;EACA,aAAA;EACA,sBAAA;AACD;;AAEA;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AACD;;AAEA;EACC,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AACD;;AAEA;EACC,YAAA;EACA,kBAAA;AACD;;AAEA;EACC,mBAAA;EACA,YAAA;EACA,eAAA;AACD;;AAEA;EACC,YAAA;EACA,sCAAA;EACA,0BAAA;AACD;;AACA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;AAED;AADC;EACC,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGF;AADE;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AAGH;AADE;EACC,YAAA;EACA,WAAA;EACA,eAAA;AAGH;AACE;EACC,sCAAA;EACA,wCAAA;AACH;AAOA;EACC,eAAA;EACA,4BAAA;EACA,WAAA;AALD;;AAQA;EACC,qBAAA;AALD;;AAOA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAJD;;AAMA;EACC,SAAA;AAHD;;AAKA;EACC,yBAAA;AAFD;AAGC;EACC,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AADF;AAEE;EACC,OAAA;EACA,+BAAA;AAAH;;AAKA;EACC,YAAA;AAFD;;AAIA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AADD;AAEC;EACC,SAAA;AAAF;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAAD;AACC;EACC,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AACF;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACD;AAAC;EACC,sBAAA;EACA,uBAAA;EACA,SAAA;AAEF;;AACA;EACC,iBAAA;AAED;;AACA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAED;;AAAA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AAGD;;AAAA;EACC,aAAA;EACA,mBAAA;AAGD;;AAAA;EACC,eAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,qBAAA;AAGD;AC3ME;EDmMF;IAQE,aAAA;EAIA;AACF;;AADA;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAID;;AADA;EACC,kBAAA;AAID","sourcesContent":["@use '../../../theme/mixins' as *;\n\napp-menu-modal {\n\tposition: relative;\n\tbackground: black;\n\ttext-transform: capitalize;\n}\n.header-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: rgba(0, 0, 0, 0.05);\n\twidth: 100%;\n\theight: 55px;\n\tmargin-bottom: 20px;\n}\n.wrapper {\n\tcolor: var(--ion-color-primary);\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.separator {\n\twidth: 100%;\n\theight: 1px;\n\tmargin: 16px 0;\n\tbackground: white;\n}\n\nion-icon {\n\twidth: 32px;\n\tmargin-right: 3px;\n\tpadding: 4px;\n\tborder-radius: 0;\n}\n\n.version {\n\topacity: 0.3;\n\tfont-size: x-small;\n}\n\nion-row {\n\talign-items: center;\n\tpadding: 2px;\n\tcursor: pointer;\n}\n\nion-button {\n\tcolor: white;\n\t--background: rgba(255, 255, 255, 0.3);\n\tbackdrop-filter: blur(4px);\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 5px;\n\tmax-width: max-content;\n\tmargin-right: auto;\n\tdiv {\n\t\ttext-align: center;\n\t\twidth: 48%;\n\t\tborder: 1px solid #0f0f0e;\n\t\tbackground: #3c3c3b;\n\t\tborder-radius: var(--radius-default);\n\t\toverflow: hidden;\n\t\tpadding: 2px 6px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\tspan {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t\tion-icon {\n\t\t\theight: 15px;\n\t\t\twidth: 15px;\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\tdiv {\n\t\t&.selected {\n\t\t\tbackground: var(--ion-color-secondary);\n\t\t\tborder-color: var(--ion-color-secondary);\n\n\t\t\tspan {\n\t\t\t\t// color: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\nion-col {\n\tfont-size: 13px;\n\tfont-family: AppFontSemiBold;\n\tcolor: #000;\n}\n\n.selected {\n\topacity: 1 !important;\n}\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\nion-icon {\n\tzoom: 1.1;\n}\n.logout {\n\tmargin: 20px 0px 0px 10px;\n\tion-button {\n\t\tpadding: 10px 0px;\n\t\tfont-family: AppFont, sans-serif;\n\t\ttext-transform: capitalize;\n\t\t--background: white;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-weight: 700;\n\t\tion-icon {\n\t\t\tzoom: 1;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n.header-wrap {\n\tmargin: 10px;\n}\n.lang-row {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\tbackground: #80735d;\n\tpadding: 15px;\n\tion-icon {\n\t\tzoom: 1.3;\n\t}\n}\n.lang-section {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tion-button {\n\t\twidth: 48%;\n\t\t--border-color: #303030;\n\t\t--background: transparent;\n\t\t--border-width: 2px;\n\t\t--border-style: solid;\n\t\tborder-radius: 3px;\n\t\t--border-radius: 3px;\n\t\toverflow: hidden;\n\t\tbackground: transparent;\n\t\tfont-weight: bold;\n\t}\n}\n.icon-lang {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-left: 10px;\n\tion-icon {\n\t\tmargin: 0px !important;\n\t\tpadding: 0px !important;\n\t\tzoom: 1.6;\n\t}\n}\n.lang-block {\n\tmargin-top: 10rem;\n}\n\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\n.version {\n\tposition: absolute;\n\tbottom: 3px;\n\tright: 10px;\n}\n\n.link {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.top-corner {\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0;\n\twidth: 17.3%;\n\taspect-ratio: 114 / 153;\n\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.logo {\n\twidth: 39px;\n\theight: 38px;\n\tpadding: 0;\n\tpadding-left: 16px;\n}\n\n.item {\n\tpadding-left: 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
